import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { FormGroup, Label, Input } from "reactstrap";

import { Form, Link, Description, Text } from "../../assets/styles/components";
import { siteParams } from "../../config/site";
import ContentBox from "../../components/ContentBox";
import Submit from "../../components/Submit";
import { Creators as PasswordCreators } from "../../store/ducks/password";
import { IS_APP } from "../../services/target";

class Password extends Component {
  static propTypes = {
    forgot: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired
  };

  state = {
    resetType: "email",
    placeValue: ""
  };

  text = {
    email: "Caso a sua conta seja localizada, enviaremos um e-mail com instruções de como redefinir sua senha.",
    phone:
      "Caso a sua conta seja localizada, enviaremos uma mensagem de texto com um código de redefinição da sua senha."
  };

  submitPassword = (e, forgot) => {
    e.preventDefault();
    forgot(e.target.place.value, e.target.resetType.value);
  };

  chengeResetType = e => {
    this.setState({ resetType: e.target.value, placeValue: "" });
  };

  render() {
    const { forgot, loading } = this.props;
    return (
      <Fragment>
        <ContentBox title="Recuperar Senha">
          {!IS_APP && (
            <Description>Como você quer redefinir sua senha?</Description>
          )}
          <Form
            accept-charset="UTF-8"
            onSubmit={e => this.submitPassword(e, forgot)}
          >
            <FormGroup tag="fieldset" className="ml-2">
              <FormGroup check className="mb-3">
                <Label check>
                  <Input
                    type="radio"
                    value="phone"
                    name="resetType"
                    onChange={this.chengeResetType}
                  />
                  <strong>Assinantes via Celular</strong>
                  <br />
                  <small>
                    Assinantes via operadora de celular (
                    {siteParams.name === "Bebanca" ? "Vivo" : "Nextel"})
                  </small>
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    value="email"
                    name="resetType"
                    defaultChecked
                    onChange={this.chengeResetType}
                  />
                  <strong>Outros meios de assinatura</strong>
                  {siteParams.name === "Bebanca" && (
                    <Fragment>
                      <br />
                      <small>
                        Assinantes via cartão de crédito, voucher e outros
                      </small>
                    </Fragment>
                  )}
                </Label>
              </FormGroup>
            </FormGroup>
            <Text>{this.text[this.state.resetType]}</Text>
            <FormGroup>
              <Input
                placeholder={
                  this.state.resetType === "email"
                    ? "E-mail"
                    : "Digite seu celular com DDD (somente números)"
                }
                name="place"
                type={this.state.resetType === "email" ? "email" : "tel"}
                required
                value={this.state.placeValue}
                onChange={t => this.setState({ placeValue: t.target.value })}
                pattern={
                  this.state.resetType === "phone" ? "^[1-9]{2}9[0-9]{8}$" : null
                }
              />
            </FormGroup>
            <Submit
              loading={loading}
              name={`Enviar ${
                this.state.resetType === "email" ? "e-mail" : "sms"
                }`}
            />
          </Form>

          {!IS_APP && (
            <Fragment>
              <Link to="/signin" className="linkClean">
                Entrar
              </Link>
              <br />
              <Link to="/signup" className="linkClean">
                Criar conta
              </Link>
            </Fragment>
          )}
        </ContentBox>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.password.loading
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(PasswordCreators, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Password);



// WEBPACK FOOTER //
// ./src/pages/password/index.js